import React from 'react';

import CountrySelectBase from './country-select-base';
import { countriesList } from './generated/country-info';
import { ICountrySelectProps } from './types';

const CountrySelect = ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  disclaimer: _disclaimerIgnoredForAllButTH,
  ...propsMinusDisclaimer
}: ICountrySelectProps) => (
  <CountrySelectBase {...propsMinusDisclaimer} countries={countriesList} />
);

export default CountrySelect;
